import { render } from "./ZoneUpdate.vue?vue&type=template&id=ba1136de&scoped=true"
import script from "./ZoneUpdate.vue?vue&type=script&lang=js"
export * from "./ZoneUpdate.vue?vue&type=script&lang=js"

import "./ZoneUpdate.vue?vue&type=style&index=0&id=ba1136de&scoped=true&lang=less"

import exportComponent from "/home/biktorgj/Projects/Linube Cloud/Server_and_UI/ui-prod-4.22/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ba1136de"]])

export default __exports__